'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from '#pplx/frontend/aether/components/Link/index.js';
import { HeadingPrimitive } from '#pplx/frontend/aether/primitives/HeadingPrimitive/index.js';
import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import React, { useEffect, useMemo } from 'react';
const DebugDatadogLink = Dynamic(async () => {
    const { DebugDatadogLink } = await import('#pplx/frontend/restricted-feature-debug-datadog-link/index.js');
    return { default: DebugDatadogLink };
}, { restricted: true });
export const GlobalErrorFactory = (base) => {
    const Component = React.memo(function GlobalError({ error, }) {
        const digest = useMemo(() => error.digest || safeRandomUUID(), [error]);
        useEffect(() => {
            logger.error(error, {
                digest,
                globalError: true,
            });
        }, [digest, error]);
        return (_jsx("div", { className: "bg-subtle flex h-screen items-center justify-center", children: _jsxs("div", { className: "p-8 flex flex-col gap-1", children: [_jsx(HeadingPrimitive, { level: 1, children: "Internal Error" }), _jsx(HeadingPrimitive, { level: 2, size: "tiny", color: "quieter", children: `#${digest}` }), _jsx(DebugDatadogLink, { digest: digest }), _jsx(Link, { href: base, hardNav: true, children: "Return home" })] }) }));
    });
    Component.displayName = `GlobalError(${base})`;
    return Component;
};
//# sourceMappingURL=GlobalError.js.map